// ©2024 Austin App House. All rights reserved.
import React from 'react';
import { connect } from 'react-redux';
import { submit } from 'redux-form';

const ControlButtonsSection = ({
  closeModal,
  submit,
}) => {
  const cancel = (event) => {
    event.preventDefault();
    closeModal();
  };

  const handlerSave = async event => {
    event.preventDefault();
    submit('addFundingSourceToDwollaBySuperAdminReduxForm');
  };

  return (
    <div className="popup_footer popup_footer--funding-source">
      <button
        type="button"
        className="dashboard-btn dashboard-btn--secondary dashboard-btn--cancel"
        aria-label="cancel"
        onClick={cancel}
      >
        Cancel
      </button>
      <button
        type="button"
        className="dashboard-btn dashboard-btn--primary dashboard-btn--save"
        name="save"
        aria-label="Save and verify funding source"
        onClick={handlerSave}
      >
        Save & Verify
      </button>
    </div>
  );
};

const mapDispatchToProps = {
  submit,
};

export default connect(null, mapDispatchToProps)(ControlButtonsSection);
